// Per-transaction buyer secret: the success URL handed to Stripe/Viva/PayZen is
// public by nature, so the status endpoint only answers to the browser that
// started the purchase. Keys live in sessionStorage (same tab, survives PSP
// redirects) with a localStorage fallback (new tab after a 3DS/app switch).
const PREFIX = 'ck:';

const stores = () => {
  const out = [];
  try { out.push(window.sessionStorage); } catch { /* blocked */ }
  try { out.push(window.localStorage); } catch { /* blocked */ }
  return out;
};

export const rememberCheckoutKey = (data) => {
  if (!data || !data.access_key) return;
  const ids = [data.tx_id, data.payment_intent_id].filter(Boolean);
  stores().forEach((s) => ids.forEach((id) => { try { s.setItem(PREFIX + id, data.access_key); } catch { /* quota */ } }));
};

export const getCheckoutKey = (id) => {
  if (!id) return '';
  for (const s of stores()) {
    try { const v = s.getItem(PREFIX + id); if (v) return v; } catch { /* blocked */ }
  }
  return '';
};

// Attach to any axios instance: captures access_key from creation responses.
export const captureCheckoutKeys = (instance) => {
  instance.interceptors.response.use((res) => {
    if (res?.config?.method === 'post' && res?.data && typeof res.data === 'object' && res.data.access_key) rememberCheckoutKey(res.data);
    return res;
  });
};
